import { Box, Skeleton, Stack } from '@mui/material'

const ModalTransfersSkeleton = () => {
  return (
    <Box display="flex" flexDirection="column" padding="16px" height="90vh">
      <Box alignItems="center" display="flex">
        <Skeleton height="48px" variant="circular" width="48px" />
        <Box ml="8px">
          <Skeleton height="60px" variant="text" width="250px" />
        </Box>
      </Box>
      <Stack gap={1}>
        <Box width="100%">
          <Skeleton height="100px" variant="rectangular" />
        </Box>
        <Box width="100%">
          <Skeleton height="100px" variant="rectangular" />
        </Box>
        <Box width="100%">
          <Skeleton height="100px" variant="rectangular" />
        </Box>
        <Box width="100%">
          <Skeleton height="100px" variant="rectangular" />
        </Box>
        <Box width="100%">
          <Skeleton height="100px" variant="rectangular" />
        </Box>
        <Box width="100%">
          <Skeleton height="100px" variant="rectangular" />
        </Box>
        <Box width="100%">
          <Skeleton height="100px" variant="rectangular" />
        </Box>
      </Stack>
    </Box>
  )
}

export default ModalTransfersSkeleton
